module.exports = __webpack_public_path__ + "img/716049_D1C8B9_3F160C_BAA6A9-256px.58fc6fbd.png";